import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  url: Yup.string().required('An url is required.').url('A valid url is required.'),
  events: Yup.array().of(Yup.string()).min(1, 'At least one event is required.'),
})
